import {LanguageSelectItem} from './language-select-item';

export const LANGUAGE_SELECT_DATA: LanguageSelectItem[] = [
  {
    id: 'https://w3id.org/idsa/code/MULTI_LINGUAL',
    idShort: 'MULTI_LINGUAL',
    label: 'Multilingual',
    comment:
      'Code indicates that several languages are used or no concrete language can be determined.',
  },

  {
    id: 'https://w3id.org/idsa/code/AB',
    idShort: 'AB',
    label: 'Abkhaz',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ab',
  },

  {
    id: 'https://w3id.org/idsa/code/AA',
    idShort: 'AA',
    label: 'Afar',
    sameAs: 'https://dbpedia.org/resource/ISO_639:aa',
  },

  {
    id: 'https://w3id.org/idsa/code/AF',
    idShort: 'AF',
    label: 'Afrikaans',
    sameAs: 'https://dbpedia.org/resource/ISO_639:af',
  },

  {
    id: 'https://w3id.org/idsa/code/AK',
    idShort: 'AK',
    label: 'Akan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ak',
  },

  {
    id: 'https://w3id.org/idsa/code/SQ',
    idShort: 'SQ',
    label: 'Albanian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sq',
  },

  {
    id: 'https://w3id.org/idsa/code/AM',
    idShort: 'AM',
    label: 'Amharic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:am',
  },

  {
    id: 'https://w3id.org/idsa/code/AR',
    idShort: 'AR',
    label: 'Arabic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ar',
  },

  {
    id: 'https://w3id.org/idsa/code/AN',
    idShort: 'AN',
    label: 'Aragonese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:an',
  },

  {
    id: 'https://w3id.org/idsa/code/HY',
    idShort: 'HY',
    label: 'Armenian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:hy',
  },

  {
    id: 'https://w3id.org/idsa/code/AS',
    idShort: 'AS',
    label: 'Assamese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:as',
  },

  {
    id: 'https://w3id.org/idsa/code/AV',
    idShort: 'AV',
    label: 'Avaric',
    sameAs: 'https://dbpedia.org/resource/ISO_639:av',
  },

  {
    id: 'https://w3id.org/idsa/code/AE',
    idShort: 'AE',
    label: 'Avestan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ae',
  },

  {
    id: 'https://w3id.org/idsa/code/AY',
    idShort: 'AY',
    label: 'Aymara',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ay',
  },

  {
    id: 'https://w3id.org/idsa/code/AZ',
    idShort: 'AZ',
    label: 'Azerbaijani',
    sameAs: 'https://dbpedia.org/resource/ISO_639:az',
  },

  {
    id: 'https://w3id.org/idsa/code/BM',
    idShort: 'BM',
    label: 'Bambara',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bm',
  },

  {
    id: 'https://w3id.org/idsa/code/BA',
    idShort: 'BA',
    label: 'Bashkir',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ba',
  },

  {
    id: 'https://w3id.org/idsa/code/EU',
    idShort: 'EU',
    label: 'Basque',
    sameAs: 'https://dbpedia.org/resource/ISO_639:eu',
  },

  {
    id: 'https://w3id.org/idsa/code/BE',
    idShort: 'BE',
    label: 'Belarusian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:be',
  },

  {
    id: 'https://w3id.org/idsa/code/BN',
    idShort: 'BN',
    label: 'Bengali, Bangla',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bn',
  },

  {
    id: 'https://w3id.org/idsa/code/BH',
    idShort: 'BH',
    label: 'Bihari',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bh',
  },

  {
    id: 'https://w3id.org/idsa/code/BI',
    idShort: 'BI',
    label: 'Bislama',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bi',
  },

  {
    id: 'https://w3id.org/idsa/code/BS',
    idShort: 'BS',
    label: 'Bosnian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bs',
  },

  {
    id: 'https://w3id.org/idsa/code/BR',
    idShort: 'BR',
    label: 'Breton',
    sameAs: 'https://dbpedia.org/resource/ISO_639:br',
  },

  {
    id: 'https://w3id.org/idsa/code/BG',
    idShort: 'BG',
    label: 'Bulgarian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bg',
  },

  {
    id: 'https://w3id.org/idsa/code/MY',
    idShort: 'MY',
    label: 'Burmese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:my',
  },

  {
    id: 'https://w3id.org/idsa/code/CA',
    idShort: 'CA',
    label: 'Catalan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ca',
  },

  {
    id: 'https://w3id.org/idsa/code/CH',
    idShort: 'CH',
    label: 'Chamorro',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ch',
  },

  {
    id: 'https://w3id.org/idsa/code/CE',
    idShort: 'CE',
    label: 'Chechen',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ce',
  },

  {
    id: 'https://w3id.org/idsa/code/NY',
    idShort: 'NY',
    label: 'Chichewa, Chewa, Nyanja',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ny',
  },

  {
    id: 'https://w3id.org/idsa/code/ZH',
    idShort: 'ZH',
    label: 'Chinese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:zh',
  },

  {
    id: 'https://w3id.org/idsa/code/CV',
    idShort: 'CV',
    label: 'Chuvash',
    sameAs: 'https://dbpedia.org/resource/ISO_639:cv',
  },

  {
    id: 'https://w3id.org/idsa/code/KW',
    idShort: 'KW',
    label: 'Cornish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kw',
  },

  {
    id: 'https://w3id.org/idsa/code/CO',
    idShort: 'CO',
    label: 'Corsican',
    sameAs: 'https://dbpedia.org/resource/ISO_639:co',
  },

  {
    id: 'https://w3id.org/idsa/code/CR',
    idShort: 'CR',
    label: 'Cree',
    sameAs: 'https://dbpedia.org/resource/ISO_639:cr',
  },

  {
    id: 'https://w3id.org/idsa/code/HR',
    idShort: 'HR',
    label: 'Croatian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:hr',
  },

  {
    id: 'https://w3id.org/idsa/code/CS',
    idShort: 'CS',
    label: 'Czech',
    sameAs: 'https://dbpedia.org/resource/ISO_639:cs',
  },

  {
    id: 'https://w3id.org/idsa/code/DA',
    idShort: 'DA',
    label: 'Danish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:da',
  },

  {
    id: 'https://w3id.org/idsa/code/DV',
    idShort: 'DV',
    label: 'Divehi, Dhivehi, Maldivian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:dv',
  },

  {
    id: 'https://w3id.org/idsa/code/NL',
    idShort: 'NL',
    label: 'Dutch',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nl',
  },

  {
    id: 'https://w3id.org/idsa/code/DZ',
    idShort: 'DZ',
    label: 'Dzongkha',
    sameAs: 'https://dbpedia.org/resource/ISO_639:dz',
  },

  {
    id: 'https://w3id.org/idsa/code/EN',
    idShort: 'EN',
    label: 'English',
    sameAs: 'https://dbpedia.org/resource/ISO_639:en',
  },

  {
    id: 'https://w3id.org/idsa/code/EO',
    idShort: 'EO',
    label: 'Esperanto',
    sameAs: 'https://dbpedia.org/resource/ISO_639:eo',
  },

  {
    id: 'https://w3id.org/idsa/code/ET',
    idShort: 'ET',
    label: 'Estonian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:et',
  },

  {
    id: 'https://w3id.org/idsa/code/EE',
    idShort: 'EE',
    label: 'Ewe',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ee',
  },

  {
    id: 'https://w3id.org/idsa/code/FO',
    idShort: 'FO',
    label: 'Faroese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fo',
  },

  {
    id: 'https://w3id.org/idsa/code/FJ',
    idShort: 'FJ',
    label: 'Fijian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fj',
  },

  {
    id: 'https://w3id.org/idsa/code/FI',
    idShort: 'FI',
    label: 'Finnish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fi',
  },

  {
    id: 'https://w3id.org/idsa/code/FR',
    idShort: 'FR',
    label: 'French',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fr',
  },

  {
    id: 'https://w3id.org/idsa/code/FF',
    idShort: 'FF',
    label: 'Fula, Fulah, Pulaar, Pular',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ff',
  },

  {
    id: 'https://w3id.org/idsa/code/GL',
    idShort: 'GL',
    label: 'Galician',
    sameAs: 'https://dbpedia.org/resource/ISO_639:gl',
  },

  {
    id: 'https://w3id.org/idsa/code/KA',
    idShort: 'KA',
    label: 'Georgian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ka',
  },

  {
    id: 'https://w3id.org/idsa/code/DE',
    idShort: 'DE',
    label: 'German',
    sameAs: 'https://dbpedia.org/resource/ISO_639:de',
  },

  {
    id: 'https://w3id.org/idsa/code/EL',
    idShort: 'EL',
    label: 'Greek (modern)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:el',
  },

  {
    id: 'https://w3id.org/idsa/code/GN',
    idShort: 'GN',
    label: 'Guaraní',
    sameAs: 'https://dbpedia.org/resource/ISO_639:gn',
  },

  {
    id: 'https://w3id.org/idsa/code/GU',
    idShort: 'GU',
    label: 'Gujarati',
    sameAs: 'https://dbpedia.org/resource/ISO_639:gu',
  },

  {
    id: 'https://w3id.org/idsa/code/HT',
    idShort: 'HT',
    label: 'Haitian, Haitian Creole',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ht',
  },

  {
    id: 'https://w3id.org/idsa/code/HA',
    idShort: 'HA',
    label: 'Hausa',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ha',
  },

  {
    id: 'https://w3id.org/idsa/code/HE',
    idShort: 'HE',
    label: 'Hebrew (modern)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:he',
  },

  {
    id: 'https://w3id.org/idsa/code/HZ',
    idShort: 'HZ',
    label: 'Herero',
    sameAs: 'https://dbpedia.org/resource/ISO_639:hz',
  },

  {
    id: 'https://w3id.org/idsa/code/HI',
    idShort: 'HI',
    label: 'Hindi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:hi',
  },

  {
    id: 'https://w3id.org/idsa/code/HO',
    idShort: 'HO',
    label: 'Hiri Motu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ho',
  },

  {
    id: 'https://w3id.org/idsa/code/HU',
    idShort: 'HU',
    label: 'Hungarian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:hu',
  },

  {
    id: 'https://w3id.org/idsa/code/IA',
    idShort: 'IA',
    label: 'Interlingua',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ia',
  },

  {
    id: 'https://w3id.org/idsa/code/ID',
    idShort: 'ID',
    label: 'Indonesian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:id',
  },

  {
    id: 'https://w3id.org/idsa/code/IE',
    idShort: 'IE',
    label: 'Interlingue',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ie',
  },

  {
    id: 'https://w3id.org/idsa/code/GA',
    idShort: 'GA',
    label: 'Irish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ga',
  },

  {
    id: 'https://w3id.org/idsa/code/IG',
    idShort: 'IG',
    label: 'Igbo',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ig',
  },

  {
    id: 'https://w3id.org/idsa/code/IK',
    idShort: 'IK',
    label: 'Inupiaq',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ik',
  },

  {
    id: 'https://w3id.org/idsa/code/IO',
    idShort: 'IO',
    label: 'Ido',
    sameAs: 'https://dbpedia.org/resource/ISO_639:io',
  },

  {
    id: 'https://w3id.org/idsa/code/IS',
    idShort: 'IS',
    label: 'Icelandic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:is',
  },

  {
    id: 'https://w3id.org/idsa/code/IT',
    idShort: 'IT',
    label: 'Italian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:it',
  },

  {
    id: 'https://w3id.org/idsa/code/IU',
    idShort: 'IU',
    label: 'Inuktitut',
    sameAs: 'https://dbpedia.org/resource/ISO_639:iu',
  },

  {
    id: 'https://w3id.org/idsa/code/JA',
    idShort: 'JA',
    label: 'Japanese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ja',
  },

  {
    id: 'https://w3id.org/idsa/code/JV',
    idShort: 'JV',
    label: 'Javanese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:jv',
  },

  {
    id: 'https://w3id.org/idsa/code/KL',
    idShort: 'KL',
    label: 'Kalaallisut, Greenlandic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kl',
  },

  {
    id: 'https://w3id.org/idsa/code/KN',
    idShort: 'KN',
    label: 'Kannada',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kn',
  },

  {
    id: 'https://w3id.org/idsa/code/KR',
    idShort: 'KR',
    label: 'Kanuri',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kr',
  },

  {
    id: 'https://w3id.org/idsa/code/KS',
    idShort: 'KS',
    label: 'Kashmiri',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ks',
  },

  {
    id: 'https://w3id.org/idsa/code/KK',
    idShort: 'KK',
    label: 'Kazakh',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kk',
  },

  {
    id: 'https://w3id.org/idsa/code/KM',
    idShort: 'KM',
    label: 'Khmer',
    sameAs: 'https://dbpedia.org/resource/ISO_639:km',
  },

  {
    id: 'https://w3id.org/idsa/code/KI',
    idShort: 'KI',
    label: 'Kikuyu, Gikuyu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ki',
  },

  {
    id: 'https://w3id.org/idsa/code/RW',
    idShort: 'RW',
    label: 'Kinyarwanda',
    sameAs: 'https://dbpedia.org/resource/ISO_639:rw',
  },

  {
    id: 'https://w3id.org/idsa/code/KY',
    idShort: 'KY',
    label: 'Kyrgyz',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ky',
  },

  {
    id: 'https://w3id.org/idsa/code/KV',
    idShort: 'KV',
    label: 'Komi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kv',
  },

  {
    id: 'https://w3id.org/idsa/code/KG',
    idShort: 'KG',
    label: 'Kongo',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kg',
  },

  {
    id: 'https://w3id.org/idsa/code/KO',
    idShort: 'KO',
    label: 'Korean',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ko',
  },

  {
    id: 'https://w3id.org/idsa/code/KU',
    idShort: 'KU',
    label: 'Kurdish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ku',
  },

  {
    id: 'https://w3id.org/idsa/code/KJ',
    idShort: 'KJ',
    label: 'Kwanyama, Kuanyama',
    sameAs: 'https://dbpedia.org/resource/ISO_639:kj',
  },

  {
    id: 'https://w3id.org/idsa/code/LA',
    idShort: 'LA',
    label: 'Latin',
    sameAs: 'https://dbpedia.org/resource/ISO_639:la',
  },

  {
    id: 'https://w3id.org/idsa/code/LB',
    idShort: 'LB',
    label: 'Luxembourgish, Letzeburgesch',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lb',
  },

  {
    id: 'https://w3id.org/idsa/code/LG',
    idShort: 'LG',
    label: 'Ganda',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lg',
  },

  {
    id: 'https://w3id.org/idsa/code/LI',
    idShort: 'LI',
    label: 'Limburgish, Limburgan, Limburger',
    sameAs: 'https://dbpedia.org/resource/ISO_639:li',
  },

  {
    id: 'https://w3id.org/idsa/code/LN',
    idShort: 'LN',
    label: 'Lingala',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ln',
  },

  {
    id: 'https://w3id.org/idsa/code/LO',
    idShort: 'LO',
    label: 'Lao',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lo',
  },

  {
    id: 'https://w3id.org/idsa/code/LT',
    idShort: 'LT',
    label: 'Lithuanian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lt',
  },

  {
    id: 'https://w3id.org/idsa/code/LU',
    idShort: 'LU',
    label: 'Luba-Katanga',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lu',
  },

  {
    id: 'https://w3id.org/idsa/code/LV',
    idShort: 'LV',
    label: 'Latvian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:lv',
  },

  {
    id: 'https://w3id.org/idsa/code/GV',
    idShort: 'GV',
    label: 'Manx',
    sameAs: 'https://dbpedia.org/resource/ISO_639:gv',
  },

  {
    id: 'https://w3id.org/idsa/code/MK',
    idShort: 'MK',
    label: 'Macedonian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mk',
  },

  {
    id: 'https://w3id.org/idsa/code/MG',
    idShort: 'MG',
    label: 'Malagasy',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mg',
  },

  {
    id: 'https://w3id.org/idsa/code/MS',
    idShort: 'MS',
    label: 'Malay',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ms',
  },

  {
    id: 'https://w3id.org/idsa/code/ML',
    idShort: 'ML',
    label: 'Malayalam',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ml',
  },

  {
    id: 'https://w3id.org/idsa/code/MT',
    idShort: 'MT',
    label: 'Maltese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mt',
  },

  {
    id: 'https://w3id.org/idsa/code/MI',
    idShort: 'MI',
    label: 'Māori',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mi',
  },

  {
    id: 'https://w3id.org/idsa/code/MR',
    idShort: 'MR',
    label: 'Marathi (Marāṭhī)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mr',
  },

  {
    id: 'https://w3id.org/idsa/code/MH',
    idShort: 'MH',
    label: 'Marshallese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mh',
  },

  {
    id: 'https://w3id.org/idsa/code/MN',
    idShort: 'MN',
    label: 'Mongolian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:mn',
  },

  {
    id: 'https://w3id.org/idsa/code/NA',
    idShort: 'NA',
    label: 'Nauruan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:na',
  },

  {
    id: 'https://w3id.org/idsa/code/NV',
    idShort: 'NV',
    label: 'Navajo, Navaho',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nv',
  },

  {
    id: 'https://w3id.org/idsa/code/ND',
    idShort: 'ND',
    label: 'Northern Ndebele',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nd',
  },

  {
    id: 'https://w3id.org/idsa/code/NE',
    idShort: 'NE',
    label: 'Nepali',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ne',
  },

  {
    id: 'https://w3id.org/idsa/code/NG',
    idShort: 'NG',
    label: 'Ndonga',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ng',
  },

  {
    id: 'https://w3id.org/idsa/code/NB',
    idShort: 'NB',
    label: 'Norwegian Bokmål',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nb',
  },

  {
    id: 'https://w3id.org/idsa/code/NN',
    idShort: 'NN',
    label: 'Norwegian Nynorsk',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nn',
  },

  {
    id: 'https://w3id.org/idsa/code/NO',
    idShort: 'NO',
    label: 'Norwegian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:no',
  },

  {
    id: 'https://w3id.org/idsa/code/II',
    idShort: 'II',
    label: 'Nuosu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ii',
  },

  {
    id: 'https://w3id.org/idsa/code/NR',
    idShort: 'NR',
    label: 'Southern Ndebele',
    sameAs: 'https://dbpedia.org/resource/ISO_639:nr',
  },

  {
    id: 'https://w3id.org/idsa/code/OC',
    idShort: 'OC',
    label: 'Occitan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:oc',
  },

  {
    id: 'https://w3id.org/idsa/code/OJ',
    idShort: 'OJ',
    label: 'Ojibwe, Ojibwa',
    sameAs: 'https://dbpedia.org/resource/ISO_639:oj',
  },

  {
    id: 'https://w3id.org/idsa/code/CU',
    idShort: 'CU',
    label: 'Old Church Slavonic, Church Slavonic, Old Bulgarian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:cu',
  },

  {
    id: 'https://w3id.org/idsa/code/OM',
    idShort: 'OM',
    label: 'Oromo',
    sameAs: 'https://dbpedia.org/resource/ISO_639:om',
  },

  {
    id: 'https://w3id.org/idsa/code/OR',
    idShort: 'OR',
    label: 'Oriya',
    sameAs: 'https://dbpedia.org/resource/ISO_639:or',
  },

  {
    id: 'https://w3id.org/idsa/code/OS',
    idShort: 'OS',
    label: 'Ossetian, Ossetic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:os',
  },

  {
    id: 'https://w3id.org/idsa/code/PA',
    idShort: 'PA',
    label: '(Eastern) Punjabi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:pa',
  },

  {
    id: 'https://w3id.org/idsa/code/PI',
    idShort: 'PI',
    label: 'Pāli',
    sameAs: 'https://dbpedia.org/resource/ISO_639:pi',
  },

  {
    id: 'https://w3id.org/idsa/code/FA',
    idShort: 'FA',
    label: 'Persian (Farsi)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fa',
  },

  {
    id: 'https://w3id.org/idsa/code/PL',
    idShort: 'PL',
    label: 'Polish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:pl',
  },

  {
    id: 'https://w3id.org/idsa/code/PS',
    idShort: 'PS',
    label: 'Pashto, Pushto',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ps',
  },

  {
    id: 'https://w3id.org/idsa/code/PT',
    idShort: 'PT',
    label: 'Portuguese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:pt',
  },

  {
    id: 'https://w3id.org/idsa/code/QU',
    idShort: 'QU',
    label: 'Quechua',
    sameAs: 'https://dbpedia.org/resource/ISO_639:qu',
  },

  {
    id: 'https://w3id.org/idsa/code/RM',
    idShort: 'RM',
    label: 'Romansh',
    sameAs: 'https://dbpedia.org/resource/ISO_639:rm',
  },

  {
    id: 'https://w3id.org/idsa/code/RN',
    idShort: 'RN',
    label: 'Kirundi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:rn',
  },

  {
    id: 'https://w3id.org/idsa/code/RO',
    idShort: 'RO',
    label: 'Romanian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ro',
  },

  {
    id: 'https://w3id.org/idsa/code/RU',
    idShort: 'RU',
    label: 'Russian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ru',
  },

  {
    id: 'https://w3id.org/idsa/code/SA',
    idShort: 'SA',
    label: 'Sanskrit (Saṁskṛta)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sa',
  },

  {
    id: 'https://w3id.org/idsa/code/SC',
    idShort: 'SC',
    label: 'Sardinian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sc',
  },

  {
    id: 'https://w3id.org/idsa/code/SD',
    idShort: 'SD',
    label: 'Sindhi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sd',
  },

  {
    id: 'https://w3id.org/idsa/code/SE',
    idShort: 'SE',
    label: 'Northern Sami',
    sameAs: 'https://dbpedia.org/resource/ISO_639:se',
  },

  {
    id: 'https://w3id.org/idsa/code/SM',
    idShort: 'SM',
    label: 'Samoan',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sm',
  },

  {
    id: 'https://w3id.org/idsa/code/SG',
    idShort: 'SG',
    label: 'Sango',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sg',
  },

  {
    id: 'https://w3id.org/idsa/code/SR',
    idShort: 'SR',
    label: 'Serbian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sr',
  },

  {
    id: 'https://w3id.org/idsa/code/GD',
    idShort: 'GD',
    label: 'Scottish Gaelic, Gaelic',
    sameAs: 'https://dbpedia.org/resource/ISO_639:gd',
  },

  {
    id: 'https://w3id.org/idsa/code/SN',
    idShort: 'SN',
    label: 'Shona',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sn',
  },

  {
    id: 'https://w3id.org/idsa/code/SI',
    idShort: 'SI',
    label: 'Sinhalese, Sinhala',
    sameAs: 'https://dbpedia.org/resource/ISO_639:si',
  },

  {
    id: 'https://w3id.org/idsa/code/SK',
    idShort: 'SK',
    label: 'Slovak',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sk',
  },

  {
    id: 'https://w3id.org/idsa/code/SL',
    idShort: 'SL',
    label: 'Slovene',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sl',
  },

  {
    id: 'https://w3id.org/idsa/code/SO',
    idShort: 'SO',
    label: 'Somali',
    sameAs: 'https://dbpedia.org/resource/ISO_639:so',
  },

  {
    id: 'https://w3id.org/idsa/code/ST',
    idShort: 'ST',
    label: 'outhern Sotho',
    sameAs: 'https://dbpedia.org/resource/ISO_639:st',
  },

  {
    id: 'https://w3id.org/idsa/code/ES',
    idShort: 'ES',
    label: 'Spanish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:es',
  },

  {
    id: 'https://w3id.org/idsa/code/SU',
    idShort: 'SU',
    label: 'Sundanese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:su',
  },

  {
    id: 'https://w3id.org/idsa/code/SW',
    idShort: 'SW',
    label: 'Swahili',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sw',
  },

  {
    id: 'https://w3id.org/idsa/code/SS',
    idShort: 'SS',
    label: 'Swati',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ss',
  },

  {
    id: 'https://w3id.org/idsa/code/SV',
    idShort: 'SV',
    label: 'Swedish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:sv',
  },

  {
    id: 'https://w3id.org/idsa/code/TA',
    idShort: 'TA',
    label: 'Tamil',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ta',
  },

  {
    id: 'https://w3id.org/idsa/code/TE',
    idShort: 'TE',
    label: 'Telugu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:te',
  },

  {
    id: 'https://w3id.org/idsa/code/TG',
    idShort: 'TG',
    label: 'Tajik',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tg',
  },

  {
    id: 'https://w3id.org/idsa/code/TH',
    idShort: 'TH',
    label: 'Thai',
    sameAs: 'https://dbpedia.org/resource/ISO_639:th',
  },

  {
    id: 'https://w3id.org/idsa/code/TI',
    idShort: 'TI',
    label: 'Tigrinya',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ti',
  },

  {
    id: 'https://w3id.org/idsa/code/BO',
    idShort: 'BO',
    label: 'Tibetan Standard, Tibetan, Central',
    sameAs: 'https://dbpedia.org/resource/ISO_639:bo',
  },

  {
    id: 'https://w3id.org/idsa/code/TK',
    idShort: 'TK',
    label: 'Turkmen',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tk',
  },

  {
    id: 'https://w3id.org/idsa/code/TL',
    idShort: 'TL',
    label: 'Tagalog',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tl',
  },

  {
    id: 'https://w3id.org/idsa/code/TN',
    idShort: 'TN',
    label: 'Tswana',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tn',
  },

  {
    id: 'https://w3id.org/idsa/code/TO',
    idShort: 'TO',
    label: 'Tonga (Tonga Islands)',
    sameAs: 'https://dbpedia.org/resource/ISO_639:to',
  },

  {
    id: 'https://w3id.org/idsa/code/TR',
    idShort: 'TR',
    label: 'Turkish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tr',
  },

  {
    id: 'https://w3id.org/idsa/code/TS',
    idShort: 'TS',
    label: 'Tsonga',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ts',
  },

  {
    id: 'https://w3id.org/idsa/code/TT',
    idShort: 'TT',
    label: 'Tatar',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tt',
  },

  {
    id: 'https://w3id.org/idsa/code/TW',
    idShort: 'TW',
    label: 'Twi',
    sameAs: 'https://dbpedia.org/resource/ISO_639:tw',
  },

  {
    id: 'https://w3id.org/idsa/code/TY',
    idShort: 'TY',
    label: 'Tahitian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ty',
  },

  {
    id: 'https://w3id.org/idsa/code/UG',
    idShort: 'UG',
    label: 'Uyghur',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ug',
  },

  {
    id: 'https://w3id.org/idsa/code/UK',
    idShort: 'UK',
    label: 'Ukrainian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:uk',
  },

  {
    id: 'https://w3id.org/idsa/code/UR',
    idShort: 'UR',
    label: 'Urdu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ur',
  },

  {
    id: 'https://w3id.org/idsa/code/UZ',
    idShort: 'UZ',
    label: 'Uzbek',
    sameAs: 'https://dbpedia.org/resource/ISO_639:uz',
  },

  {
    id: 'https://w3id.org/idsa/code/VE',
    idShort: 'VE',
    label: 'Venda',
    sameAs: 'https://dbpedia.org/resource/ISO_639:ve',
  },

  {
    id: 'https://w3id.org/idsa/code/VI',
    idShort: 'VI',
    label: 'Vietnamese',
    sameAs: 'https://dbpedia.org/resource/ISO_639:vi',
  },

  {
    id: 'https://w3id.org/idsa/code/VO',
    idShort: 'VO',
    label: 'Volapük',
    sameAs: 'https://dbpedia.org/resource/ISO_639:vo',
  },

  {
    id: 'https://w3id.org/idsa/code/WA',
    idShort: 'WA',
    label: 'Walloon',
    sameAs: 'https://dbpedia.org/resource/ISO_639:wa',
  },

  {
    id: 'https://w3id.org/idsa/code/CY',
    idShort: 'CY',
    label: 'Welsh',
    sameAs: 'https://dbpedia.org/resource/ISO_639:cy',
  },

  {
    id: 'https://w3id.org/idsa/code/WO',
    idShort: 'WO',
    label: 'Wolof',
    sameAs: 'https://dbpedia.org/resource/ISO_639:wo',
  },

  {
    id: 'https://w3id.org/idsa/code/FY',
    idShort: 'FY',
    label: 'Western Frisian',
    sameAs: 'https://dbpedia.org/resource/ISO_639:fy',
  },

  {
    id: 'https://w3id.org/idsa/code/XH',
    idShort: 'XH',
    label: 'Xhosa',
    sameAs: 'https://dbpedia.org/resource/ISO_639:xh',
  },

  {
    id: 'https://w3id.org/idsa/code/YI',
    idShort: 'YI',
    label: 'Yiddish',
    sameAs: 'https://dbpedia.org/resource/ISO_639:yi',
  },

  {
    id: 'https://w3id.org/idsa/code/YO',
    idShort: 'YO',
    label: 'Yoruba',
    sameAs: 'https://dbpedia.org/resource/ISO_639:yo',
  },

  {
    id: 'https://w3id.org/idsa/code/ZA',
    idShort: 'ZA',
    label: 'Zhuang, Chuang',
    sameAs: 'https://dbpedia.org/resource/ISO_639:za',
  },

  {
    id: 'https://w3id.org/idsa/code/ZU',
    idShort: 'ZU',
    label: 'Zulu',
    sameAs: 'https://dbpedia.org/resource/ISO_639:zu',
  },
];
